import { gsap } from 'gsap'
import SplitType from 'split-type'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'
import { debounce } from './debounce'
import './scroll'
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(CustomEase)

let mm = gsap.matchMedia()

const mainSubsans2 = new SplitType('.main-subsans2', { types: 'words' })
const subsans2Words = document.querySelectorAll('.main-subsans2 .word')

const revealSubsans2 = () => {
    gsap.from('.main-subsans2 .word', {
        opacity: 0,
        delay: 0.5,
        duration: 1,
        stagger: { each: 0.5 },
    })
}

const revealListIcons = (itemsList) => {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.features-box',
            start: 'top 70%',
        },
    })
    tl.from(itemsList, {
        opacity: 0,
        translateY: 20,
        duration: 1,
        stagger: { each: 0.35 },
    })
}
const parallaxToTop = (element, trigger) => {
    gsap.fromTo(
        element,
        {
            y: '15%',
            scale: 1,
        },
        {
            y: '-20%',
            scrollTrigger: {
                trigger: trigger,
                scrub: 1,
                end: '90% 15%',
            },
        }
    )
}

window.addEventListener('load', function () {
    const scrollColorElems = document.querySelectorAll('[data-bgcolor]')
    scrollColorElems.forEach((colorSection, i) => {
        // const prevBg = i === 0 ? "" : scrollColorElems[i - 1].dataset.bgcolor;
        // const prevText = i === 0 ? "" : scrollColorElems[i - 1].dataset.textcolor;

        ScrollTrigger.create({
            trigger: colorSection,
            start: 'top 50%',
            onEnter: () =>
                gsap.to(colorSection, {
                    backgroundColor: colorSection.dataset.bgcolor,
                    color: colorSection.dataset.textcolor,
                    overwrite: 'auto',
                }),
            // onLeaveBack: () =>
            //   gsap.to(colorSection, {
            //     backgroundColor: prevBg,
            //     color: prevText,
            //     overwrite: "auto"
            //   })
        })
    })
})

if (document.querySelector('.main-subsans2')) revealSubsans2()
if (document.querySelector('.features-box'))
    revealListIcons('.features-box>div')
mm.add('(min-width: 1024px)', () => {
    if (document.querySelector('.parallax-tt-trigger')) {
        document.querySelectorAll('.parallax-tt-trigger').forEach((element) => {
            parallaxToTop(element, element)
        })
    }
})

const itemsToOverlay = document.querySelectorAll(
    '.is-overlay-first, .is-overlay-second'
)

itemsToOverlay.forEach((item) => {
    const delay = item.classList.contains('overlay-delay') ? 1 : 0.5

    gsap.fromTo(
        item,
        {
            y: 0,
        },
        {
            y: '100%',
            duration: 1,
            scrollTrigger: {
                trigger: item,
                start: 'top 80%',
                end: 'top 20%',
                delay: delay * 1000,
                duration: 1,
                onEnter: () => {
                    gsap.to(item, {
                        y: '100%',
                        duration: 2,
                        onComplete: () => {},
                    })
                },
                onLeaveBack: () => {
                    gsap.to(item, {
                        y: 0,
                        duration: 2,
                    })
                },
            },
        }
    )
})

function animateEntry(itemToEntry, startX, startY) {
    gsap.set(itemToEntry, {
        opacity: 0,
        y: startY,
        x: startX,
    })

    gsap.to(itemToEntry, {
        opacity: 1,
        y: 0,
        x: 0,
        duration: 2,
        ease: 'steps(1)',
        scrollTrigger: {
            trigger: itemToEntry,
            start: 'top 90%',
            end: 'bottom 30%',
            // toggleActions: "play none none none",
            onEnter: () => {
                gsap.to(itemToEntry, {
                    opacity: 1,
                    y: 0,
                    x: 0,
                    duration: 1.5,
                    onComplete: () => {
                        // Add any additional onComplete logic here if needed
                    },
                })
            },
            onLeaveBack: () => {
                gsap.to(itemToEntry, {
                    opacity: 0,
                    y: startY,
                    x: startX,
                    duration: 1,
                })
            },
        },
    })
}

const entryElements = (trigger) => {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: trigger,
            once: true,
        },
    })

    tl.fromTo(
        trigger,
        {
            y: 50,
            opacity: 0,
        },
        {
            y: 0,
            duration: 1.2,
            opacity: 1,
            stagger: 0.6,
        }
    )
}

// Entries from the left
const itemsToEntryLeft = document.querySelectorAll('.entry-gsap-left')
itemsToEntryLeft.forEach(function (itemToEntry) {
    animateEntry(itemToEntry, -300, 0)
})

// Entries from the right
const itemsToEntryRight = document.querySelectorAll('.entry-gsap-right')
itemsToEntryRight.forEach(function (itemToEntry) {
    animateEntry(itemToEntry, 300, 0)
})

// Entries from the top
const itemsToEntryTop = document.querySelectorAll('.entry-gsap-top')
itemsToEntryTop.forEach(function (itemToEntry) {
    animateEntry(itemToEntry, 0, -100)
})

// Entries from the bottom
const itemsToEntryBottom = document.querySelectorAll('.entry-gsap-bottom')
itemsToEntryBottom.forEach(function (itemToEntry) {
    animateEntry(itemToEntry, 0, 100)
})

mm.add('(min-width: 1024px)', () => {
    // Entries from the left
    const itemsToEntryLeft = document.querySelectorAll('.entry-gsap-left')
    itemsToEntryLeft.forEach(function (itemToEntry) {
        animateEntry(itemToEntry, -300, 0)
    })

    // Entries from the right
    const itemsToEntryRight = document.querySelectorAll('.entry-gsap-right')
    itemsToEntryRight.forEach(function (itemToEntry) {
        animateEntry(itemToEntry, 300, 0)
    })

    // Entries from the top
    const itemsToEntryTop = document.querySelectorAll('.entry-gsap-top')
    itemsToEntryTop.forEach(function (itemToEntry) {
        animateEntry(itemToEntry, 0, -100)
    })

    // Entries from the bottom
    const itemsToEntryBottom = document.querySelectorAll('.entry-gsap-bottom')
    itemsToEntryBottom.forEach(function (itemToEntry) {
        animateEntry(itemToEntry, 0, 100)
    })

    if (document.querySelector('.entry-element'))
        entryElements('.entry-element')
})
